/** venta = precio de venta · alquiler = precio/mes · alquiler_temporario = precio del período */
import { CAD_STOCK_LABELS } from '../../Showroom/data/cadConstants';

export {
  CAD_STOCK_STATUS_ITEMS as STOCK_STATUS_ITEMS,
  CAD_STOCK_STATUSES as STOCK_STATUSES,
  CAD_STOCK_LABELS as STOCK_STATUS_LABELS,
} from '../../Showroom/data/cadConstants';

export const OPERATIONS = [
  { value: 'venta', label: 'Venta' },
  { value: 'alquiler', label: 'Alquiler' },
  { value: 'alquiler_temporario', label: 'Alquiler temporario' },
];

export const OPERATION_LABEL = Object.fromEntries(
  OPERATIONS.map(({ value, label }) => [value, label]),
);

export const CURRENCIES = ['USD', 'ARS', 'EUR'];

export const CURRENCY_OPTIONS = CURRENCIES.map((value) => ({ value, label: value }));

export const formatListingPrice = (price, currency = 'USD') => {
  if (price == null || price === '') return null;
  const amount = Number(price);
  if (!Number.isFinite(amount)) return null;
  const formatted = amount.toLocaleString('es-AR', { maximumFractionDigits: 0 });
  return `${currency || 'USD'} ${formatted}`;
};

/** Solo dígitos para persistir el monto en el form (separadores de miles se ignoran). */
export const parsePriceInputValue = (value) => String(value ?? '').replace(/\D/g, '');

/** Visual: 10000 → "10.000" (es-AR). El form guarda el valor sin separadores. */
export const formatPriceInputDisplay = (value) => {
  if (value == null || value === '') return '';
  const asNumber = Number(String(value).replace(',', '.'));
  if (Number.isFinite(asNumber)) {
    return Math.trunc(Math.abs(asNumber)).toLocaleString('es-AR', { maximumFractionDigits: 0 });
  }
  const digits = parsePriceInputValue(value);
  if (!digits) return '';
  return Number(digits).toLocaleString('es-AR', { maximumFractionDigits: 0 });
};

/** Label ES de stock_status; desconocido / vacío → Disponible. */
export function getStockStatusLabel(status) {
  if (!status) return CAD_STOCK_LABELS.available;
  return CAD_STOCK_LABELS[status] || status;
}
